export const INIT_FLIP_STATE = 'flipState/INIT'

export const initFlipState = curState => {
  return {
    curState,
    type: INIT_FLIP_STATE,
  }
}

export default (state = false, action) => {
  switch (action.type) {
    case INIT_FLIP_STATE:
      return action.curState
    default:
      return state
  }
}
